import LegalPage from "../components/LegalPage";

const SECTIONS = [
  {
    h: "Our commitment",
    ps: [
      "Barverse aims to meet WCAG 2.1 Level AA across barverse.com. A dark, dramatic design is only worth building if everyone can read it.",
    ],
  },
  {
    h: "What that means in practice",
    ps: [
      "Text and background color combinations are kept above minimum contrast thresholds, including on the dark theme.",
      "The site is built with semantic HTML landmarks, works with keyboard navigation alone, and shows a visible focus outline when tabbing.",
      "Meaningful images carry descriptive alternative text, and information is never conveyed by color alone.",
      "All form fields have visible labels, and errors are announced in text — not just by color.",
      "Animations respect your device's reduced-motion setting: smooth scrolling, reveals and the marquee are disabled automatically.",
    ],
  },
  {
    h: "Known limitations",
    ps: [
      "Site imagery currently consists of architectural renderings of the planned Barverse concept rather than final photography; alt text describes each rendering accurately.",
    ],
  },
  {
    h: "Feedback",
    ps: [
      "If anything on this site is hard to use with your assistive technology, email info@tacoverse.com and we will fix it.",
    ],
  },
];

export default function Accessibility() {
  return (
    <LegalPage
      testid="accessibility-page"
      path="/accessibility"
      title="Accessibility"
      description="barverse.com accessibility statement — WCAG commitments, keyboard navigation, contrast, reduced motion and how to send feedback."
      updated="October 2026"
      intro="Barverse should feel open to everyone — online too. Here is exactly what we hold ourselves to."
      sections={SECTIONS}
    />
  );
}
